import React from 'react';

import { WarningMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { RadioButtonPanels } from '@eika/radio-button';

import { PinChangeOption, RadioButtonOption, SiteCoreDictionary } from '../types';

import './Form.scss';

interface FormContentProps {
    selectedOption: PinChangeOption | undefined;
    setSelectedOption: (option: PinChangeOption | undefined) => void;
    pinChangeDecisionError: string | undefined;
    dictionary: SiteCoreDictionary;
    isOrderingNewDebitCard?: boolean;
}

const FormContent = ({
    selectedOption,
    setSelectedOption,
    pinChangeDecisionError,
    dictionary,
    isOrderingNewDebitCard,
}: FormContentProps) => {
    const {
        changePinAttentionMessageText1,
        changePinAttentionMessageText2,
        changePinRadioOption,
        keepPinRadioOption,
        pinChangeDecisionFormTitle,
        orderNewCardSkipPin,
        orderNewCardSelectPin,
        pinChangeDecisionFormTitleForNewCard,
    } = dictionary;

    const OPTIONS: RadioButtonOption[] = [
        {
            id: PinChangeOption.KEEP_PIN,
            value: PinChangeOption.KEEP_PIN,
            label: isOrderingNewDebitCard ? orderNewCardSkipPin : keepPinRadioOption,
            ...{
                'data-track-id': 'pin-change-decision-option',
                'data-track-linkname': PinChangeOption.KEEP_PIN,
            },
        },
        {
            id: PinChangeOption.CHANGE_PIN,
            value: PinChangeOption.CHANGE_PIN,
            label: isOrderingNewDebitCard ? orderNewCardSelectPin : changePinRadioOption,
            ...{
                'data-track-id': 'pin-change-decision-option',
                'data-track-linkname': PinChangeOption.CHANGE_PIN,
            },
        },
    ];

    return (
        <div className="pin-change-decision-form">
            {isOrderingNewDebitCard ? pinChangeDecisionFormTitleForNewCard : pinChangeDecisionFormTitle}
            <RadioButtonPanels
                label=""
                name="pin-change-decision-form__radio-buttons"
                onChange={(value: string) => setSelectedOption(value as PinChangeOption)}
                selectedOption={selectedOption}
                options={OPTIONS}
                errorMessage={pinChangeDecisionError}
            />

            {selectedOption === PinChangeOption.CHANGE_PIN && (
                <WarningMessage
                    icon={IconTypes.INFO_24}
                    text={`${changePinAttentionMessageText1} ${changePinAttentionMessageText2}`}
                />
            )}
        </div>
    );
};

export default FormContent;
